"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBreakpoints = exports.infinityName = exports.defaultOrientation = exports.CALCULATE_RESPONSIVE_STATE = exports.NAME = void 0;
var types_1 = require("./types");
exports.NAME = 'viewport';
exports.CALCULATE_RESPONSIVE_STATE = 'viewport/CALCULATE_RESPONSIVE_STATE';
// orientation to default to when no `window` present
exports.defaultOrientation = types_1.Orientation.Landscape;
exports.infinityName = 'infinity';
exports.defaultBreakpoints = (_a = {
        superExtraSmall: 360,
        extraSmall: 480,
        small: 768,
        medium: 992,
        large: 1200,
        major: 1366,
        extraMajor: 1439,
        great: 1680,
        extraLarge: 1920
    },
    _a[exports.infinityName] = Infinity,
    _a);
//# sourceMappingURL=constants.js.map